import { render, staticRenderFns } from "./HotelMinPriceButtonSeo.vue?vue&type=template&id=39222ede&lang=pug&"
import script from "./HotelMinPriceButtonSeo.vue?vue&type=script&lang=ts&"
export * from "./HotelMinPriceButtonSeo.vue?vue&type=script&lang=ts&"
import style0 from "./HotelMinPriceButtonSeo.vue?vue&type=style&index=0&id=39222ede&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports